var _excluded = ["mainAxis", "crossAxis", "fallbackPlacements", "fallbackStrategy", "fallbackAxisSideDirection", "flipAlignment"],
    _excluded2 = ["mainAxis", "crossAxis", "limiter"],
    _excluded3 = ["apply"];

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { proxyCustomElement, HTMLElement as HTMLElement$1, h, Host } from '@stencil/core/internal/client';
import { c as clsnms } from './utils.js';
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */

var min = Math.min;
var max = Math.max;
var round = Math.round;
var floor = Math.floor;

var createCoords = function createCoords(v) {
  return {
    x: v,
    y: v
  };
};

var oppositeSideMap = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
var oppositeAlignmentMap = {
  start: 'end',
  end: 'start'
};

function clamp(start, value, end) {
  return max(start, min(value, end));
}

function evaluate(value, param) {
  return typeof value === 'function' ? value(param) : value;
}

function getSide(placement) {
  return placement.split('-')[0];
}

function getAlignment(placement) {
  return placement.split('-')[1];
}

function getOppositeAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function getAxisLength(axis) {
  return axis === 'y' ? 'height' : 'width';
}

function getSideAxis(placement) {
  return ['top', 'bottom'].includes(getSide(placement)) ? 'y' : 'x';
}

function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}

function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }

  var alignment = getAlignment(placement);
  var alignmentAxis = getAlignmentAxis(placement);
  var length = getAxisLength(alignmentAxis);
  var mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';

  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }

  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}

function getExpandedPlacements(placement) {
  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}

function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, function (alignment) {
    return oppositeAlignmentMap[alignment];
  });
}

function getSideList(side, isStart, rtl) {
  var lr = ['left', 'right'];
  var rl = ['right', 'left'];
  var tb = ['top', 'bottom'];
  var bt = ['bottom', 'top'];

  switch (side) {
    case 'top':
    case 'bottom':
      if (rtl) return isStart ? rl : lr;
      return isStart ? lr : rl;

    case 'left':
    case 'right':
      return isStart ? tb : bt;

    default:
      return [];
  }
}

function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  var alignment = getAlignment(placement);
  var list = getSideList(getSide(placement), direction === 'start', rtl);

  if (alignment) {
    list = list.map(function (side) {
      return side + "-" + alignment;
    });

    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }

  return list;
}

function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (side) {
    return oppositeSideMap[side];
  });
}

function expandPaddingObject(padding) {
  return _objectSpread({
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }, padding);
}

function getPaddingObject(padding) {
  return typeof padding !== 'number' ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}

function rectToClientRect(rect) {
  var x = rect.x,
      y = rect.y,
      width = rect.width,
      height = rect.height;
  return {
    width: width,
    height: height,
    top: y,
    left: x,
    right: x + width,
    bottom: y + height,
    x: x,
    y: y
  };
}

function computeCoordsFromPlacement(_ref, placement, rtl) {
  var reference = _ref.reference,
      floating = _ref.floating;
  var sideAxis = getSideAxis(placement);
  var alignmentAxis = getAlignmentAxis(placement);
  var alignLength = getAxisLength(alignmentAxis);
  var side = getSide(placement);
  var isVertical = sideAxis === 'y';
  var commonX = reference.x + reference.width / 2 - floating.width / 2;
  var commonY = reference.y + reference.height / 2 - floating.height / 2;
  var commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  var coords;

  switch (side) {
    case 'top':
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;

    case 'bottom':
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case 'right':
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case 'left':
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;

    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }

  switch (getAlignment(placement)) {
    case 'start':
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;

    case 'end':
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }

  return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */


var computePosition$1 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(reference, floating, config) {
    var _config$placement, placement, _config$strategy, strategy, _config$middleware, middleware, platform, validMiddleware, rtl, rects, _computeCoordsFromPla, x, y, statefulPlacement, middlewareData, resetCount, i, _validMiddleware$i, name, fn, _yield$fn, nextX, nextY, data, reset, _computeCoordsFromPla2;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _config$placement = config.placement, placement = _config$placement === void 0 ? 'bottom' : _config$placement, _config$strategy = config.strategy, strategy = _config$strategy === void 0 ? 'absolute' : _config$strategy, _config$middleware = config.middleware, middleware = _config$middleware === void 0 ? [] : _config$middleware, platform = config.platform;
          validMiddleware = middleware.filter(Boolean);
          _context.next = 4;
          return platform.isRTL == null ? void 0 : platform.isRTL(floating);

        case 4:
          rtl = _context.sent;
          _context.next = 7;
          return platform.getElementRects({
            reference: reference,
            floating: floating,
            strategy: strategy
          });

        case 7:
          rects = _context.sent;
          _computeCoordsFromPla = computeCoordsFromPlacement(rects, placement, rtl), x = _computeCoordsFromPla.x, y = _computeCoordsFromPla.y;
          statefulPlacement = placement;
          middlewareData = {};
          resetCount = 0;
          i = 0;

        case 13:
          if (!(i < validMiddleware.length)) {
            _context.next = 45;
            break;
          }

          _validMiddleware$i = validMiddleware[i], name = _validMiddleware$i.name, fn = _validMiddleware$i.fn;
          _context.next = 17;
          return fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
              reference: reference,
              floating: floating
            }
          });

        case 17:
          _yield$fn = _context.sent;
          nextX = _yield$fn.x;
          nextY = _yield$fn.y;
          data = _yield$fn.data;
          reset = _yield$fn.reset;
          x = nextX != null ? nextX : x;
          y = nextY != null ? nextY : y;
          middlewareData = _objectSpread(_objectSpread({}, middlewareData), {}, _defineProperty({}, name, _objectSpread(_objectSpread({}, middlewareData[name]), data)));

          if (!(reset && resetCount <= 50)) {
            _context.next = 42;
            break;
          }

          resetCount++;

          if (!(_typeof(reset) === 'object')) {
            _context.next = 41;
            break;
          }

          if (reset.placement) {
            statefulPlacement = reset.placement;
          }

          if (!reset.rects) {
            _context.next = 38;
            break;
          }

          if (!(reset.rects === true)) {
            _context.next = 36;
            break;
          }

          _context.next = 33;
          return platform.getElementRects({
            reference: reference,
            floating: floating,
            strategy: strategy
          });

        case 33:
          _context.t0 = _context.sent;
          _context.next = 37;
          break;

        case 36:
          _context.t0 = reset.rects;

        case 37:
          rects = _context.t0;

        case 38:
          _computeCoordsFromPla2 = computeCoordsFromPlacement(rects, statefulPlacement, rtl);
          x = _computeCoordsFromPla2.x;
          y = _computeCoordsFromPla2.y;

        case 41:
          i = -1;

        case 42:
          i++;
          _context.next = 13;
          break;

        case 45:
          return _context.abrupt("return", {
            x: x,
            y: y,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData
          });

        case 46:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));

  return function computePosition$1(_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */


function detectOverflow(_x4, _x5) {
  return _detectOverflow.apply(this, arguments);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */


function _detectOverflow() {
  _detectOverflow = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(state, options) {
    var _await$platform$isEle, x, y, platform, rects, elements, strategy, _evaluate4, _evaluate4$boundary, boundary, _evaluate4$rootBounda, rootBoundary, _evaluate4$elementCon, elementContext, _evaluate4$altBoundar, altBoundary, _evaluate4$padding, padding, paddingObject, altContext, element, clippingClientRect, rect, offsetParent, offsetScale, elementClientRect;

    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          if (options === void 0) {
            options = {};
          }

          x = state.x, y = state.y, platform = state.platform, rects = state.rects, elements = state.elements, strategy = state.strategy;
          _evaluate4 = evaluate(options, state), _evaluate4$boundary = _evaluate4.boundary, boundary = _evaluate4$boundary === void 0 ? 'clippingAncestors' : _evaluate4$boundary, _evaluate4$rootBounda = _evaluate4.rootBoundary, rootBoundary = _evaluate4$rootBounda === void 0 ? 'viewport' : _evaluate4$rootBounda, _evaluate4$elementCon = _evaluate4.elementContext, elementContext = _evaluate4$elementCon === void 0 ? 'floating' : _evaluate4$elementCon, _evaluate4$altBoundar = _evaluate4.altBoundary, altBoundary = _evaluate4$altBoundar === void 0 ? false : _evaluate4$altBoundar, _evaluate4$padding = _evaluate4.padding, padding = _evaluate4$padding === void 0 ? 0 : _evaluate4$padding;
          paddingObject = getPaddingObject(padding);
          altContext = elementContext === 'floating' ? 'reference' : 'floating';
          element = elements[altBoundary ? altContext : elementContext];
          _context9.t0 = rectToClientRect;
          _context9.t1 = platform;
          _context9.next = 10;
          return platform.isElement == null ? void 0 : platform.isElement(element);

        case 10:
          _context9.t2 = _await$platform$isEle = _context9.sent;

          if (!(_context9.t2 != null)) {
            _context9.next = 15;
            break;
          }

          _context9.t3 = _await$platform$isEle;
          _context9.next = 16;
          break;

        case 15:
          _context9.t3 = true;

        case 16:
          if (!_context9.t3) {
            _context9.next = 20;
            break;
          }

          _context9.t4 = element;
          _context9.next = 26;
          break;

        case 20:
          _context9.t5 = element.contextElement;

          if (_context9.t5) {
            _context9.next = 25;
            break;
          }

          _context9.next = 24;
          return platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating);

        case 24:
          _context9.t5 = _context9.sent;

        case 25:
          _context9.t4 = _context9.t5;

        case 26:
          _context9.t6 = _context9.t4;
          _context9.t7 = boundary;
          _context9.t8 = rootBoundary;
          _context9.t9 = strategy;
          _context9.t10 = {
            element: _context9.t6,
            boundary: _context9.t7,
            rootBoundary: _context9.t8,
            strategy: _context9.t9
          };
          _context9.next = 33;
          return _context9.t1.getClippingRect.call(_context9.t1, _context9.t10);

        case 33:
          _context9.t11 = _context9.sent;
          clippingClientRect = (0, _context9.t0)(_context9.t11);
          rect = elementContext === 'floating' ? {
            x: x,
            y: y,
            width: rects.floating.width,
            height: rects.floating.height
          } : rects.reference;
          _context9.next = 38;
          return platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating);

        case 38:
          offsetParent = _context9.sent;
          _context9.next = 41;
          return platform.isElement == null ? void 0 : platform.isElement(offsetParent);

        case 41:
          if (!_context9.sent) {
            _context9.next = 50;
            break;
          }

          _context9.next = 44;
          return platform.getScale == null ? void 0 : platform.getScale(offsetParent);

        case 44:
          _context9.t13 = _context9.sent;

          if (_context9.t13) {
            _context9.next = 47;
            break;
          }

          _context9.t13 = {
            x: 1,
            y: 1
          };

        case 47:
          _context9.t12 = _context9.t13;
          _context9.next = 51;
          break;

        case 50:
          _context9.t12 = {
            x: 1,
            y: 1
          };

        case 51:
          offsetScale = _context9.t12;
          _context9.t14 = rectToClientRect;

          if (!platform.convertOffsetParentRelativeRectToViewportRelativeRect) {
            _context9.next = 59;
            break;
          }

          _context9.next = 56;
          return platform.convertOffsetParentRelativeRectToViewportRelativeRect({
            elements: elements,
            rect: rect,
            offsetParent: offsetParent,
            strategy: strategy
          });

        case 56:
          _context9.t15 = _context9.sent;
          _context9.next = 60;
          break;

        case 59:
          _context9.t15 = rect;

        case 60:
          _context9.t16 = _context9.t15;
          elementClientRect = (0, _context9.t14)(_context9.t16);
          return _context9.abrupt("return", {
            top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
            bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
            left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
            right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
          });

        case 63:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return _detectOverflow.apply(this, arguments);
}

var arrow$1 = function arrow$1(options) {
  return {
    name: 'arrow',
    options: options,
    fn: function fn(state) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _objectSpread3, _ref4;

        var x, y, placement, rects, platform, elements, middlewareData, _ref3, element, _ref3$padding, padding, paddingObject, coords, axis, length, arrowDimensions, isYAxis, minProp, maxProp, clientProp, endDiff, startDiff, arrowOffsetParent, clientSize, centerToReference, largestPossiblePadding, minPadding, maxPadding, min$1, max, center, offset, shouldAddOffset, alignmentOffset;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              x = state.x, y = state.y, placement = state.placement, rects = state.rects, platform = state.platform, elements = state.elements, middlewareData = state.middlewareData; // Since `element` is required, we don't Partial<> the type.

              _ref3 = evaluate(options, state) || {}, element = _ref3.element, _ref3$padding = _ref3.padding, padding = _ref3$padding === void 0 ? 0 : _ref3$padding;

              if (!(element == null)) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return", {});

            case 4:
              paddingObject = getPaddingObject(padding);
              coords = {
                x: x,
                y: y
              };
              axis = getAlignmentAxis(placement);
              length = getAxisLength(axis);
              _context2.next = 10;
              return platform.getDimensions(element);

            case 10:
              arrowDimensions = _context2.sent;
              isYAxis = axis === 'y';
              minProp = isYAxis ? 'top' : 'left';
              maxProp = isYAxis ? 'bottom' : 'right';
              clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
              endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
              startDiff = coords[axis] - rects.reference[axis];
              _context2.next = 19;
              return platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element);

            case 19:
              arrowOffsetParent = _context2.sent;
              clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0; // DOM platform can return `window` as the `offsetParent`.

              _context2.t0 = !clientSize;

              if (_context2.t0) {
                _context2.next = 26;
                break;
              }

              _context2.next = 25;
              return platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent);

            case 25:
              _context2.t0 = !_context2.sent;

            case 26:
              if (!_context2.t0) {
                _context2.next = 28;
                break;
              }

              clientSize = elements.floating[clientProp] || rects.floating[length];

            case 28:
              centerToReference = endDiff / 2 - startDiff / 2; // If the padding is large enough that it causes the arrow to no longer be
              // centered, modify the padding so that it is centered.

              largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
              minPadding = min(paddingObject[minProp], largestPossiblePadding);
              maxPadding = min(paddingObject[maxProp], largestPossiblePadding); // Make sure the arrow doesn't overflow the floating element if the center
              // point is outside the floating element's bounds.

              min$1 = minPadding;
              max = clientSize - arrowDimensions[length] - maxPadding;
              center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
              offset = clamp(min$1, center, max); // If the reference is small enough that the arrow's padding causes it to
              // to point to nothing for an aligned placement, adjust the offset of the
              // floating element itself. To ensure `shift()` continues to take action,
              // a single reset is performed when this is true.

              shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
              alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
              return _context2.abrupt("return", (_ref4 = {}, _defineProperty(_ref4, axis, coords[axis] + alignmentOffset), _defineProperty(_ref4, "data", _objectSpread((_objectSpread3 = {}, _defineProperty(_objectSpread3, axis, offset), _defineProperty(_objectSpread3, "centerOffset", center - offset - alignmentOffset), _objectSpread3), shouldAddOffset && {
                alignmentOffset: alignmentOffset
              })), _defineProperty(_ref4, "reset", shouldAddOffset), _ref4));

            case 39:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */


var flip$1 = function flip$1(options) {
  if (options === void 0) {
    options = {};
  }

  return {
    name: 'flip',
    options: options,
    fn: function fn(state) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _middlewareData$arrow, _middlewareData$flip, placement, middlewareData, rects, initialPlacement, platform, elements, _evaluate, _evaluate$mainAxis, checkMainAxis, _evaluate$crossAxis, checkCrossAxis, specifiedFallbackPlacements, _evaluate$fallbackStr, fallbackStrategy, _evaluate$fallbackAxi, fallbackAxisSideDirection, _evaluate$flipAlignme, flipAlignment, detectOverflowOptions, side, initialSideAxis, isBasePlacement, rtl, fallbackPlacements, hasFallbackAxisSideDirection, placements, overflow, overflows, overflowsData, sides, _middlewareData$flip2, _overflowsData$filter, nextIndex, nextPlacement, resetPlacement, _overflowsData$filter2, _placement;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              placement = state.placement, middlewareData = state.middlewareData, rects = state.rects, initialPlacement = state.initialPlacement, platform = state.platform, elements = state.elements;
              _evaluate = evaluate(options, state), _evaluate$mainAxis = _evaluate.mainAxis, checkMainAxis = _evaluate$mainAxis === void 0 ? true : _evaluate$mainAxis, _evaluate$crossAxis = _evaluate.crossAxis, checkCrossAxis = _evaluate$crossAxis === void 0 ? true : _evaluate$crossAxis, specifiedFallbackPlacements = _evaluate.fallbackPlacements, _evaluate$fallbackStr = _evaluate.fallbackStrategy, fallbackStrategy = _evaluate$fallbackStr === void 0 ? 'bestFit' : _evaluate$fallbackStr, _evaluate$fallbackAxi = _evaluate.fallbackAxisSideDirection, fallbackAxisSideDirection = _evaluate$fallbackAxi === void 0 ? 'none' : _evaluate$fallbackAxi, _evaluate$flipAlignme = _evaluate.flipAlignment, flipAlignment = _evaluate$flipAlignme === void 0 ? true : _evaluate$flipAlignme, detectOverflowOptions = _objectWithoutProperties(_evaluate, _excluded); // If a reset by the arrow was caused due to an alignment offset being
              // added, we should skip any logic now since `flip()` has already done its
              // work.
              // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643

              if (!((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset)) {
                _context3.next = 4;
                break;
              }

              return _context3.abrupt("return", {});

            case 4:
              side = getSide(placement);
              initialSideAxis = getSideAxis(initialPlacement);
              isBasePlacement = getSide(initialPlacement) === initialPlacement;
              _context3.next = 9;
              return platform.isRTL == null ? void 0 : platform.isRTL(elements.floating);

            case 9:
              rtl = _context3.sent;
              fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
              hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';

              if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
                fallbackPlacements.push.apply(fallbackPlacements, _toConsumableArray(getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl)));
              }

              placements = [initialPlacement].concat(_toConsumableArray(fallbackPlacements));
              _context3.next = 16;
              return detectOverflow(state, detectOverflowOptions);

            case 16:
              overflow = _context3.sent;
              overflows = [];
              overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];

              if (checkMainAxis) {
                overflows.push(overflow[side]);
              }

              if (checkCrossAxis) {
                sides = getAlignmentSides(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
              }

              overflowsData = [].concat(_toConsumableArray(overflowsData), [{
                placement: placement,
                overflows: overflows
              }]); // One or more sides is overflowing.

              if (overflows.every(function (side) {
                return side <= 0;
              })) {
                _context3.next = 39;
                break;
              }

              nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
              nextPlacement = placements[nextIndex];

              if (!nextPlacement) {
                _context3.next = 27;
                break;
              }

              return _context3.abrupt("return", {
                data: {
                  index: nextIndex,
                  overflows: overflowsData
                },
                reset: {
                  placement: nextPlacement
                }
              });

            case 27:
              // First, find the candidates that fit on the mainAxis side of overflow,
              // then find the placement that fits the best on the main crossAxis side.
              resetPlacement = (_overflowsData$filter = overflowsData.filter(function (d) {
                return d.overflows[0] <= 0;
              }).sort(function (a, b) {
                return a.overflows[1] - b.overflows[1];
              })[0]) == null ? void 0 : _overflowsData$filter.placement; // Otherwise fallback.

              if (resetPlacement) {
                _context3.next = 37;
                break;
              }

              _context3.t0 = fallbackStrategy;
              _context3.next = _context3.t0 === 'bestFit' ? 32 : _context3.t0 === 'initialPlacement' ? 35 : 37;
              break;

            case 32:
              _placement = (_overflowsData$filter2 = overflowsData.filter(function (d) {
                if (hasFallbackAxisSideDirection) {
                  var currentSideAxis = getSideAxis(d.placement);
                  return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  currentSideAxis === 'y';
                }

                return true;
              }).map(function (d) {
                return [d.placement, d.overflows.filter(function (overflow) {
                  return overflow > 0;
                }).reduce(function (acc, overflow) {
                  return acc + overflow;
                }, 0)];
              }).sort(function (a, b) {
                return a[1] - b[1];
              })[0]) == null ? void 0 : _overflowsData$filter2[0];

              if (_placement) {
                resetPlacement = _placement;
              }

              return _context3.abrupt("break", 37);

            case 35:
              resetPlacement = initialPlacement;
              return _context3.abrupt("break", 37);

            case 37:
              if (!(placement !== resetPlacement)) {
                _context3.next = 39;
                break;
              }

              return _context3.abrupt("return", {
                reset: {
                  placement: resetPlacement
                }
              });

            case 39:
              return _context3.abrupt("return", {});

            case 40:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  };
}; // For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.


function convertValueToCoords(_x6, _x7) {
  return _convertValueToCoords.apply(this, arguments);
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */


function _convertValueToCoords() {
  _convertValueToCoords = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(state, options) {
    var placement, platform, elements, rtl, side, alignment, isVertical, mainAxisMulti, crossAxisMulti, rawValue, _ref9, mainAxis, crossAxis, alignmentAxis;

    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          placement = state.placement, platform = state.platform, elements = state.elements;
          _context10.next = 3;
          return platform.isRTL == null ? void 0 : platform.isRTL(elements.floating);

        case 3:
          rtl = _context10.sent;
          side = getSide(placement);
          alignment = getAlignment(placement);
          isVertical = getSideAxis(placement) === 'y';
          mainAxisMulti = ['left', 'top'].includes(side) ? -1 : 1;
          crossAxisMulti = rtl && isVertical ? -1 : 1;
          rawValue = evaluate(options, state); // eslint-disable-next-line prefer-const

          _ref9 = typeof rawValue === 'number' ? {
            mainAxis: rawValue,
            crossAxis: 0,
            alignmentAxis: null
          } : {
            mainAxis: rawValue.mainAxis || 0,
            crossAxis: rawValue.crossAxis || 0,
            alignmentAxis: rawValue.alignmentAxis
          }, mainAxis = _ref9.mainAxis, crossAxis = _ref9.crossAxis, alignmentAxis = _ref9.alignmentAxis;

          if (alignment && typeof alignmentAxis === 'number') {
            crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
          }

          return _context10.abrupt("return", isVertical ? {
            x: crossAxis * crossAxisMulti,
            y: mainAxis * mainAxisMulti
          } : {
            x: mainAxis * mainAxisMulti,
            y: crossAxis * crossAxisMulti
          });

        case 13:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return _convertValueToCoords.apply(this, arguments);
}

var offset$1 = function offset$1(options) {
  if (options === void 0) {
    options = 0;
  }

  return {
    name: 'offset',
    options: options,
    fn: function fn(state) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _middlewareData$offse, _middlewareData$arrow, x, y, placement, middlewareData, diffCoords;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              x = state.x, y = state.y, placement = state.placement, middlewareData = state.middlewareData;
              _context4.next = 3;
              return convertValueToCoords(state, options);

            case 3:
              diffCoords = _context4.sent;

              if (!(placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset)) {
                _context4.next = 6;
                break;
              }

              return _context4.abrupt("return", {});

            case 6:
              return _context4.abrupt("return", {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: _objectSpread(_objectSpread({}, diffCoords), {}, {
                  placement: placement
                })
              });

            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    }
  };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */


var shift$1 = function shift$1(options) {
  if (options === void 0) {
    options = {};
  }

  return {
    name: 'shift',
    options: options,
    fn: function fn(state) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _objectSpread4, _enabled;

        var x, y, placement, _evaluate2, _evaluate2$mainAxis, checkMainAxis, _evaluate2$crossAxis, checkCrossAxis, _evaluate2$limiter, limiter, detectOverflowOptions, coords, overflow, crossAxis, mainAxis, mainAxisCoord, crossAxisCoord, minSide, maxSide, _min, _max, _minSide, _maxSide, _min2, _max2, limitedCoords;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              x = state.x, y = state.y, placement = state.placement;
              _evaluate2 = evaluate(options, state), _evaluate2$mainAxis = _evaluate2.mainAxis, checkMainAxis = _evaluate2$mainAxis === void 0 ? true : _evaluate2$mainAxis, _evaluate2$crossAxis = _evaluate2.crossAxis, checkCrossAxis = _evaluate2$crossAxis === void 0 ? false : _evaluate2$crossAxis, _evaluate2$limiter = _evaluate2.limiter, limiter = _evaluate2$limiter === void 0 ? {
                fn: function fn(_ref) {
                  var x = _ref.x,
                      y = _ref.y;
                  return {
                    x: x,
                    y: y
                  };
                }
              } : _evaluate2$limiter, detectOverflowOptions = _objectWithoutProperties(_evaluate2, _excluded2);
              coords = {
                x: x,
                y: y
              };
              _context5.next = 5;
              return detectOverflow(state, detectOverflowOptions);

            case 5:
              overflow = _context5.sent;
              crossAxis = getSideAxis(getSide(placement));
              mainAxis = getOppositeAxis(crossAxis);
              mainAxisCoord = coords[mainAxis];
              crossAxisCoord = coords[crossAxis];

              if (checkMainAxis) {
                minSide = mainAxis === 'y' ? 'top' : 'left';
                maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                _min = mainAxisCoord + overflow[minSide];
                _max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = clamp(_min, mainAxisCoord, _max);
              }

              if (checkCrossAxis) {
                _minSide = crossAxis === 'y' ? 'top' : 'left';
                _maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                _min2 = crossAxisCoord + overflow[_minSide];
                _max2 = crossAxisCoord - overflow[_maxSide];
                crossAxisCoord = clamp(_min2, crossAxisCoord, _max2);
              }

              limitedCoords = limiter.fn(_objectSpread(_objectSpread({}, state), {}, (_objectSpread4 = {}, _defineProperty(_objectSpread4, mainAxis, mainAxisCoord), _defineProperty(_objectSpread4, crossAxis, crossAxisCoord), _objectSpread4)));
              return _context5.abrupt("return", _objectSpread(_objectSpread({}, limitedCoords), {}, {
                data: {
                  x: limitedCoords.x - x,
                  y: limitedCoords.y - y,
                  enabled: (_enabled = {}, _defineProperty(_enabled, mainAxis, checkMainAxis), _defineProperty(_enabled, crossAxis, checkCrossAxis), _enabled)
                }
              }));

            case 14:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    }
  };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */


var size$1 = function size$1(options) {
  if (options === void 0) {
    options = {};
  }

  return {
    name: 'size',
    options: options,
    fn: function fn(state) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _state$middlewareData, _state$middlewareData2, placement, rects, platform, elements, _evaluate3, _evaluate3$apply, apply, detectOverflowOptions, overflow, side, alignment, isYAxis, _rects$floating, width, height, heightSide, widthSide, maximumClippingHeight, maximumClippingWidth, overflowAvailableHeight, overflowAvailableWidth, noShift, availableHeight, availableWidth, xMin, xMax, yMin, yMax, nextDimensions;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              placement = state.placement, rects = state.rects, platform = state.platform, elements = state.elements;
              _evaluate3 = evaluate(options, state), _evaluate3$apply = _evaluate3.apply, apply = _evaluate3$apply === void 0 ? function () {} : _evaluate3$apply, detectOverflowOptions = _objectWithoutProperties(_evaluate3, _excluded3);
              _context6.next = 4;
              return detectOverflow(state, detectOverflowOptions);

            case 4:
              overflow = _context6.sent;
              side = getSide(placement);
              alignment = getAlignment(placement);
              isYAxis = getSideAxis(placement) === 'y';
              _rects$floating = rects.floating, width = _rects$floating.width, height = _rects$floating.height;

              if (!(side === 'top' || side === 'bottom')) {
                _context6.next = 28;
                break;
              }

              heightSide = side;
              _context6.t0 = alignment;
              _context6.next = 14;
              return platform.isRTL == null ? void 0 : platform.isRTL(elements.floating);

            case 14:
              if (!_context6.sent) {
                _context6.next = 18;
                break;
              }

              _context6.t1 = 'start';
              _context6.next = 19;
              break;

            case 18:
              _context6.t1 = 'end';

            case 19:
              _context6.t2 = _context6.t1;

              if (!(_context6.t0 === _context6.t2)) {
                _context6.next = 24;
                break;
              }

              _context6.t3 = 'left';
              _context6.next = 25;
              break;

            case 24:
              _context6.t3 = 'right';

            case 25:
              widthSide = _context6.t3;
              _context6.next = 30;
              break;

            case 28:
              widthSide = side;
              heightSide = alignment === 'end' ? 'top' : 'bottom';

            case 30:
              maximumClippingHeight = height - overflow.top - overflow.bottom;
              maximumClippingWidth = width - overflow.left - overflow.right;
              overflowAvailableHeight = min(height - overflow[heightSide], maximumClippingHeight);
              overflowAvailableWidth = min(width - overflow[widthSide], maximumClippingWidth);
              noShift = !state.middlewareData.shift;
              availableHeight = overflowAvailableHeight;
              availableWidth = overflowAvailableWidth;

              if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) {
                availableWidth = maximumClippingWidth;
              }

              if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) {
                availableHeight = maximumClippingHeight;
              }

              if (noShift && !alignment) {
                xMin = max(overflow.left, 0);
                xMax = max(overflow.right, 0);
                yMin = max(overflow.top, 0);
                yMax = max(overflow.bottom, 0);

                if (isYAxis) {
                  availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max(overflow.left, overflow.right));
                } else {
                  availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max(overflow.top, overflow.bottom));
                }
              }

              _context6.next = 42;
              return apply(_objectSpread(_objectSpread({}, state), {}, {
                availableWidth: availableWidth,
                availableHeight: availableHeight
              }));

            case 42:
              _context6.next = 44;
              return platform.getDimensions(elements.floating);

            case 44:
              nextDimensions = _context6.sent;

              if (!(width !== nextDimensions.width || height !== nextDimensions.height)) {
                _context6.next = 47;
                break;
              }

              return _context6.abrupt("return", {
                reset: {
                  rects: true
                }
              });

            case 47:
              return _context6.abrupt("return", {});

            case 48:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    }
  };
};

function hasWindow() {
  return typeof window !== 'undefined';
}

function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || '').toLowerCase();
  } // Mocked nodes in testing environments may not be instances of Node. By
  // returning `#document` an infinite loop won't occur.
  // https://github.com/floating-ui/floating-ui/issues/2317


  return '#document';
}

function getWindow(node) {
  var _node$ownerDocument;

  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}

function getDocumentElement(node) {
  var _ref;

  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}

function isNode(value) {
  if (!hasWindow()) {
    return false;
  }

  return value instanceof Node || value instanceof getWindow(value).Node;
}

function isElement(value) {
  if (!hasWindow()) {
    return false;
  }

  return value instanceof Element || value instanceof getWindow(value).Element;
}

function isHTMLElement(value) {
  if (!hasWindow()) {
    return false;
  }

  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}

function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === 'undefined') {
    return false;
  }

  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}

function isOverflowElement(element) {
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY,
      display = _getComputedStyle.display;

  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !['inline', 'contents'].includes(display);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].includes(getNodeName(element));
}

function isTopLayer(element) {
  return [':popover-open', ':modal'].some(function (selector) {
    try {
      return element.matches(selector);
    } catch (e) {
      return false;
    }
  });
}

function isContainingBlock(elementOrCss) {
  var webkit = isWebKit();
  var css = isElement(elementOrCss) ? getComputedStyle(elementOrCss) : elementOrCss; // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

  return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || ['transform', 'perspective', 'filter'].some(function (value) {
    return (css.willChange || '').includes(value);
  }) || ['paint', 'layout', 'strict', 'content'].some(function (value) {
    return (css.contain || '').includes(value);
  });
}

function getContainingBlock(element) {
  var currentNode = getParentNode(element);

  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }

    currentNode = getParentNode(currentNode);
  }

  return null;
}

function isWebKit() {
  if (typeof CSS === 'undefined' || !CSS.supports) return false;
  return CSS.supports('-webkit-backdrop-filter', 'none');
}

function isLastTraversableNode(node) {
  return ['html', 'body', '#document'].includes(getNodeName(node));
}

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}

function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }

  return {
    scrollLeft: element.scrollX,
    scrollTop: element.scrollY
  };
}

function getParentNode(node) {
  if (getNodeName(node) === 'html') {
    return node;
  }

  var result = // Step into the shadow DOM of the parent of a slotted node.
  node.assignedSlot || // DOM Element detected.
  node.parentNode || // ShadowRoot detected.
  isShadowRoot(node) && node.host || // Fallback.
  getDocumentElement(node);
  return isShadowRoot(result) ? result.host : result;
}

function getNearestOverflowAncestor(node) {
  var parentNode = getParentNode(node);

  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }

  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }

  return getNearestOverflowAncestor(parentNode);
}

function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;

  if (list === void 0) {
    list = [];
  }

  if (traverseIframes === void 0) {
    traverseIframes = true;
  }

  var scrollableAncestor = getNearestOverflowAncestor(node);
  var isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  var win = getWindow(scrollableAncestor);

  if (isBody) {
    var frameElement = getFrameElement(win);
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  }

  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}

function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

function getCssDimensions(element) {
  var css = getComputedStyle(element); // In testing environments, the `width` and `height` properties are empty
  // strings for SVG elements, returning NaN. Fallback to `0` in this case.

  var width = parseFloat(css.width) || 0;
  var height = parseFloat(css.height) || 0;
  var hasOffset = isHTMLElement(element);
  var offsetWidth = hasOffset ? element.offsetWidth : width;
  var offsetHeight = hasOffset ? element.offsetHeight : height;
  var shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;

  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }

  return {
    width: width,
    height: height,
    $: shouldFallback
  };
}

function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}

function getScale(element) {
  var domElement = unwrapElement(element);

  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }

  var rect = domElement.getBoundingClientRect();

  var _getCssDimensions = getCssDimensions(domElement),
      width = _getCssDimensions.width,
      height = _getCssDimensions.height,
      $ = _getCssDimensions.$;

  var x = ($ ? round(rect.width) : rect.width) / width;
  var y = ($ ? round(rect.height) : rect.height) / height; // 0, NaN, or Infinity should always fallback to 1.

  if (!x || !Number.isFinite(x)) {
    x = 1;
  }

  if (!y || !Number.isFinite(y)) {
    y = 1;
  }

  return {
    x: x,
    y: y
  };
}

var noOffsets = /*#__PURE__*/createCoords(0);

function getVisualOffsets(element) {
  var win = getWindow(element);

  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }

  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}

function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }

  return isFixed;
}

function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var domElement = unwrapElement(element);
  var scale = createCoords(1);

  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }

  var visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  var x = (clientRect.left + visualOffsets.x) / scale.x;
  var y = (clientRect.top + visualOffsets.y) / scale.y;
  var width = clientRect.width / scale.x;
  var height = clientRect.height / scale.y;

  if (domElement) {
    var win = getWindow(domElement);
    var offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    var currentWin = win;
    var currentIFrame = getFrameElement(currentWin);

    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      var iframeScale = getScale(currentIFrame);
      var iframeRect = currentIFrame.getBoundingClientRect();
      var css = getComputedStyle(currentIFrame);
      var left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      var top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentWin = getWindow(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }

  return rectToClientRect({
    width: width,
    height: height,
    x: x,
    y: y
  });
}

function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  var elements = _ref.elements,
      rect = _ref.rect,
      offsetParent = _ref.offsetParent,
      strategy = _ref.strategy;
  var isFixed = strategy === 'fixed';
  var documentElement = getDocumentElement(offsetParent);
  var topLayer = elements ? isTopLayer(elements.floating) : false;

  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }

  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var scale = createCoords(1);
  var offsets = createCoords(0);
  var isOffsetParentAnElement = isHTMLElement(offsetParent);

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      var offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }

  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
  };
}

function getClientRects(element) {
  return Array.from(element.getClientRects());
} // If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.


function getWindowScrollBarX(element, rect) {
  var leftScroll = getNodeScroll(element).scrollLeft;

  if (!rect) {
    return getBoundingClientRect(getDocumentElement(element)).left + leftScroll;
  }

  return rect.left + leftScroll;
} // Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.


function getDocumentRect(element) {
  var html = getDocumentElement(element);
  var scroll = getNodeScroll(element);
  var body = element.ownerDocument.body;
  var width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  var height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  var x = -scroll.scrollLeft + getWindowScrollBarX(element);
  var y = -scroll.scrollTop;

  if (getComputedStyle(body).direction === 'rtl') {
    x += max(html.clientWidth, body.clientWidth) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var visualViewportBased = isWebKit();

    if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
} // Returns the inner client rect, subtracting scrollbars if present.


function getInnerBoundingClientRect(element, strategy) {
  var clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
  var top = clientRect.top + element.clientTop;
  var left = clientRect.left + element.clientLeft;
  var scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
  var width = element.clientWidth * scale.x;
  var height = element.clientHeight * scale.y;
  var x = left * scale.x;
  var y = top * scale.y;
  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  var rect;

  if (clippingAncestor === 'viewport') {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === 'document') {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    var visualOffsets = getVisualOffsets(element);
    rect = _objectSpread(_objectSpread({}, clippingAncestor), {}, {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y
    });
  }

  return rectToClientRect(rect);
}

function hasFixedPositionAncestor(element, stopNode) {
  var parentNode = getParentNode(element);

  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }

  return getComputedStyle(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
} // A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.


function getClippingElementAncestors(element, cache) {
  var cachedResult = cache.get(element);

  if (cachedResult) {
    return cachedResult;
  }

  var result = getOverflowAncestors(element, [], false).filter(function (el) {
    return isElement(el) && getNodeName(el) !== 'body';
  });
  var currentContainingBlockComputedStyle = null;
  var elementIsFixed = getComputedStyle(element).position === 'fixed';
  var currentNode = elementIsFixed ? getParentNode(element) : element; // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    var computedStyle = getComputedStyle(currentNode);
    var currentNodeIsContaining = isContainingBlock(currentNode);

    if (!currentNodeIsContaining && computedStyle.position === 'fixed') {
      currentContainingBlockComputedStyle = null;
    }

    var shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && ['absolute', 'fixed'].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);

    if (shouldDropCurrentNode) {
      // Drop non-containing blocks.
      result = result.filter(function (ancestor) {
        return ancestor !== currentNode;
      });
    } else {
      // Record last containing block for next iteration.
      currentContainingBlockComputedStyle = computedStyle;
    }

    currentNode = getParentNode(currentNode);
  }

  cache.set(element, result);
  return result;
} // Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.


function getClippingRect(_ref) {
  var element = _ref.element,
      boundary = _ref.boundary,
      rootBoundary = _ref.rootBoundary,
      strategy = _ref.strategy;
  var elementClippingAncestors = boundary === 'clippingAncestors' ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  var clippingAncestors = [].concat(_toConsumableArray(elementClippingAncestors), [rootBoundary]);
  var firstClippingAncestor = clippingAncestors[0];
  var clippingRect = clippingAncestors.reduce(function (accRect, clippingAncestor) {
    var rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}

function getDimensions(element) {
  var _getCssDimensions2 = getCssDimensions(element),
      width = _getCssDimensions2.width,
      height = _getCssDimensions2.height;

  return {
    width: width,
    height: height
  };
}

function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var isFixed = strategy === 'fixed';
  var rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = createCoords(0);

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isOffsetParentAnElement) {
      var offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
      // Firefox with layout.scrollbar.side = 3 in about:config to test this.
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  var htmlX = 0;
  var htmlY = 0;

  if (documentElement && !isOffsetParentAnElement && !isFixed) {
    var htmlRect = documentElement.getBoundingClientRect();
    htmlY = htmlRect.top + scroll.scrollTop;
    htmlX = htmlRect.left + scroll.scrollLeft - // RTL <body> scrollbar.
    getWindowScrollBarX(documentElement, htmlRect);
  }

  var x = rect.left + scroll.scrollLeft - offsets.x - htmlX;
  var y = rect.top + scroll.scrollTop - offsets.y - htmlY;
  return {
    x: x,
    y: y,
    width: rect.width,
    height: rect.height
  };
}

function isStaticPositioned(element) {
  return getComputedStyle(element).position === 'static';
}

function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || getComputedStyle(element).position === 'fixed') {
    return null;
  }

  if (polyfill) {
    return polyfill(element);
  }

  var rawOffsetParent = element.offsetParent; // Firefox returns the <html> element as the offsetParent if it's non-static,
  // while Chrome and Safari return the <body> element. The <body> element must
  // be used to perform the correct calculations even if the <html> element is
  // non-static.

  if (getDocumentElement(element) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }

  return rawOffsetParent;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element, polyfill) {
  var win = getWindow(element);

  if (isTopLayer(element)) {
    return win;
  }

  if (!isHTMLElement(element)) {
    var svgOffsetParent = getParentNode(element);

    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }

      svgOffsetParent = getParentNode(svgOffsetParent);
    }

    return win;
  }

  var offsetParent = getTrueOffsetParent(element, polyfill);

  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }

  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }

  return offsetParent || getContainingBlock(element) || win;
}

var getElementRects = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(data) {
    var getOffsetParentFn, getDimensionsFn, floatingDimensions;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          getOffsetParentFn = this.getOffsetParent || getOffsetParent;
          getDimensionsFn = this.getDimensions;
          _context7.next = 4;
          return getDimensionsFn(data.floating);

        case 4:
          floatingDimensions = _context7.sent;
          _context7.t0 = getRectRelativeToOffsetParent;
          _context7.t1 = data.reference;
          _context7.next = 9;
          return getOffsetParentFn(data.floating);

        case 9:
          _context7.t2 = _context7.sent;
          _context7.t3 = data.strategy;
          _context7.t4 = (0, _context7.t0)(_context7.t1, _context7.t2, _context7.t3);
          _context7.t5 = {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
          };
          return _context7.abrupt("return", {
            reference: _context7.t4,
            floating: _context7.t5
          });

        case 14:
        case "end":
          return _context7.stop();
      }
    }, _callee7, this);
  }));

  return function getElementRects(_x8) {
    return _ref5.apply(this, arguments);
  };
}();

function isRTL(element) {
  return getComputedStyle(element).direction === 'rtl';
}

var platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect: convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement: getDocumentElement,
  getClippingRect: getClippingRect,
  getOffsetParent: getOffsetParent,
  getElementRects: getElementRects,
  getClientRects: getClientRects,
  getDimensions: getDimensions,
  getScale: getScale,
  isElement: isElement,
  isRTL: isRTL
}; // https://samthor.au/2021/observing-dom/

function observeMove(element, onMove) {
  var io = null;
  var timeoutId;
  var root = getDocumentElement(element);

  function cleanup() {
    var _io;

    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }

  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }

    if (threshold === void 0) {
      threshold = 1;
    }

    cleanup();

    var _element$getBoundingC = element.getBoundingClientRect(),
        left = _element$getBoundingC.left,
        top = _element$getBoundingC.top,
        width = _element$getBoundingC.width,
        height = _element$getBoundingC.height;

    if (!skip) {
      onMove();
    }

    if (!width || !height) {
      return;
    }

    var insetTop = floor(top);
    var insetRight = floor(root.clientWidth - (left + width));
    var insetBottom = floor(root.clientHeight - (top + height));
    var insetLeft = floor(left);
    var rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    var options = {
      rootMargin: rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    var isFirstUpdate = true;

    function handleObserve(entries) {
      var ratio = entries[0].intersectionRatio;

      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }

        if (!ratio) {
          // If the reference is clipped, the ratio is 0. Throttle the refresh
          // to prevent an infinite loop of updates.
          timeoutId = setTimeout(function () {
            refresh(false, 1e-7);
          }, 1000);
        } else {
          refresh(false, ratio);
        }
      }

      isFirstUpdate = false;
    } // Older browsers don't support a `document` as the root and will throw an
    // error.


    try {
      io = new IntersectionObserver(handleObserve, _objectSpread(_objectSpread({}, options), {}, {
        // Handle <iframe>s
        root: root.ownerDocument
      }));
    } catch (e) {
      io = new IntersectionObserver(handleObserve, options);
    }

    io.observe(element);
  }

  refresh(true);
  return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */


function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$ancestorScro = _options.ancestorScroll,
      ancestorScroll = _options$ancestorScro === void 0 ? true : _options$ancestorScro,
      _options$ancestorResi = _options.ancestorResize,
      ancestorResize = _options$ancestorResi === void 0 ? true : _options$ancestorResi,
      _options$elementResiz = _options.elementResize,
      elementResize = _options$elementResiz === void 0 ? typeof ResizeObserver === 'function' : _options$elementResiz,
      _options$layoutShift = _options.layoutShift,
      layoutShift = _options$layoutShift === void 0 ? typeof IntersectionObserver === 'function' : _options$layoutShift,
      _options$animationFra = _options.animationFrame,
      animationFrame = _options$animationFra === void 0 ? false : _options$animationFra;
  var referenceEl = unwrapElement(reference);
  var ancestors = ancestorScroll || ancestorResize ? [].concat(_toConsumableArray(referenceEl ? getOverflowAncestors(referenceEl) : []), _toConsumableArray(getOverflowAncestors(floating))) : [];
  ancestors.forEach(function (ancestor) {
    ancestorScroll && ancestor.addEventListener('scroll', update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener('resize', update);
  });
  var cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  var reobserveFrame = -1;
  var resizeObserver = null;

  if (elementResize) {
    resizeObserver = new ResizeObserver(function (_ref) {
      var _ref6 = _slicedToArray(_ref, 1),
          firstEntry = _ref6[0];

      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        // Prevent update loops when using the `size` middleware.
        // https://github.com/floating-ui/floating-ui/issues/1740
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(function () {
          var _resizeObserver;

          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }

      update();
    });

    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }

    resizeObserver.observe(floating);
  }

  var frameId;
  var prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;

  if (animationFrame) {
    frameLoop();
  }

  function frameLoop() {
    var nextRefRect = getBoundingClientRect(reference);

    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }

    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }

  update();
  return function () {
    var _resizeObserver2;

    ancestors.forEach(function (ancestor) {
      ancestorScroll && ancestor.removeEventListener('scroll', update);
      ancestorResize && ancestor.removeEventListener('resize', update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;

    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */


var offset = offset$1;
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */

var shift = shift$1;
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */

var flip = flip$1;
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */

var size = size$1;
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */

var arrow = arrow$1;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */

var computePosition = function computePosition(reference, floating, options) {
  // This caches the expensive `getClippingElementAncestors` function so that
  // multiple lifecycle resets re-use the same result. It only lives for a
  // single call. If other functions become expensive, we can add them as well.
  var cache = new Map();

  var mergedOptions = _objectSpread({
    platform: platform
  }, options);

  var platformWithCache = _objectSpread(_objectSpread({}, mergedOptions.platform), {}, {
    _c: cache
  });

  return computePosition$1(reference, floating, _objectSpread(_objectSpread({}, mergedOptions), {}, {
    platform: platformWithCache
  }));
};

var tooltipCss = "@charset \"UTF-8\";:root{--skp-color-neutral-50:#FEFDFB;--skp-color-neutral-100:#F7F7F7;--skp-color-neutral-200:#EFEFEF;--skp-color-neutral-300:#E1E1E1;--skp-color-neutral-400:#AFB2B8;--skp-color-neutral-500:#838893;--skp-color-neutral-600:#6F747E;--skp-color-neutral-700:#565961;--skp-color-neutral-800:#313235;--skp-color-neutral-900:#02020A;--skp-color-primary-50:#ecf7ff;--skp-color-primary-100:#b8dffb;--skp-color-primary-200:#86cafb;--skp-color-primary-300:#51b3f9;--skp-color-primary-400:#33a7fa;--skp-color-primary-500:#3271f5;--skp-color-primary-600:#1f65fa;--skp-color-primary-700:#0c27f5;--skp-color-primary-800:#031289;--skp-color-primary-900:#010630;--skp-color-secondary-50:#f8f6ff;--skp-color-secondary-100:#e7e0ff;--skp-color-secondary-200:#d5c8ff;--skp-color-secondary-300:#c3b0ff;--skp-color-secondary-400:#a185fc;--skp-color-secondary-500:#7952f6;--skp-color-secondary-600:#6233f6;--skp-color-secondary-700:#3f07ee;--skp-color-secondary-800:#21037e;--skp-color-secondary-900:#150250;--skp-color-tertiary-50:#e3f2fa;--skp-color-tertiary-100:#acd7f1;--skp-color-tertiary-200:#75bce7;--skp-color-tertiary-300:#3da1de;--skp-color-tertiary-400:#2080bb;--skp-color-tertiary-500:#1b6d9f;--skp-color-tertiary-600:#185f8b;--skp-color-tertiary-700:#114463;--skp-color-tertiary-800:#0a293c;--skp-color-tertiary-900:#030e14;--skp-color-quaternary-50:#fbebf5;--skp-color-quaternary-100:#f4c3e0;--skp-color-quaternary-200:#ed9acb;--skp-color-quaternary-300:#e572b7;--skp-color-quaternary-400:#de4aa2;--skp-color-quaternary-500:#da3698;--skp-color-quaternary-600:#c92587;--skp-color-quaternary-700:#901a60;--skp-color-quaternary-800:#56103a;--skp-color-quaternary-900:#1d0513;--skp-color-alternative1-50:#FFF4EF;--skp-color-alternative1-100:#FFD9C5;--skp-color-alternative1-200:#FFBD99;--skp-color-alternative1-300:#FFA270;--skp-color-alternative1-400:#FF8036;--skp-color-alternative1-500:#FF8036;--skp-color-alternative1-600:#FF6911;--skp-color-alternative1-700:#D95102;--skp-color-alternative1-800:#A83E00;--skp-color-alternative1-900:#802900;--skp-color-alternative2-50:#FBF5EF;--skp-color-alternative2-100:#F9EBDD;--skp-color-alternative2-200:#F3E1CF;--skp-color-alternative2-300:#F2DCC6;--skp-color-alternative2-400:#F0D4B7;--skp-color-alternative2-500:#EECAA6;--skp-color-alternative2-600:#E7B98B;--skp-color-alternative2-700:#E1A970;--skp-color-alternative2-800:#D29659;--skp-color-alternative2-900:#CA7F32;--skp-color-alternative3-50:#F4FDFF;--skp-color-alternative3-100:#EBFBFF;--skp-color-alternative3-200:#DAF8FF;--skp-color-alternative3-300:#CEF5FF;--skp-color-alternative3-400:#BEF2FF;--skp-color-alternative3-500:#B0EBFF;--skp-color-alternative3-600:#A3EAFC;--skp-color-alternative3-700:#8DE1F5;--skp-color-alternative3-800:#69D8F4;--skp-color-alternative3-900:#37C1E3;--skp-color-alternative4-50:#F8F4FF;--skp-color-alternative4-100:#E9DFFF;--skp-color-alternative4-200:#CFBAFF;--skp-color-alternative4-300:#BB9EFF;--skp-color-alternative4-400:#9E76FF;--skp-color-alternative4-500:#8257FF;--skp-color-alternative4-600:#922BFA;--skp-color-alternative4-700:#8519C7;--skp-color-alternative4-800:#6D13A4;--skp-color-alternative4-900:#401A54;--skp-color-success-50:#F7FFF3;--skp-color-success-100:#DAFFC6;--skp-color-success-200:#A8FF80;--skp-color-success-300:#71F550;--skp-color-success-400:#51D94F;--skp-color-success-500:#1CBA63;--skp-color-success-600:#00A67E;--skp-color-success-700:#12703D;--skp-color-success-800:#0A5C56;--skp-color-success-900:#003C37;--skp-color-warning-50:#FFF5DD;--skp-color-warning-100:#FFEDC0;--skp-color-warning-200:#FFD682;--skp-color-warning-300:#FFCC50;--skp-color-warning-400:#FFBF22;--skp-color-warning-500:#FFB529;--skp-color-warning-600:#FFAF09;--skp-color-warning-700:#CF8E06;--skp-color-warning-800:#A67309;--skp-color-warning-900:#804F1A;--skp-color-error-50:#FFF5F8;--skp-color-error-100:#FFDAE4;--skp-color-error-200:#FFBAC9;--skp-color-error-300:#FFA5A5;--skp-color-error-400:#FF8573;--skp-color-error-500:#FF5C45;--skp-color-error-600:#F53434;--skp-color-error-700:#DF1723;--skp-color-error-800:#B50E36;--skp-color-error-900:#801442;--skp-color-dark-50:#383838;--skp-color-dark-100:#363636;--skp-color-dark-200:#333;--skp-color-dark-300:#2e2e2e;--skp-color-dark-400:#2c2c2c;--skp-color-dark-500:#272727;--skp-color-dark-600:#252525;--skp-color-dark-700:#232323;--skp-color-dark-800:#1e1e1e;--skp-color-dark-900:#121212;--skp-color-white:#fff;--skp-color-black:#000}:root{--skp-rem-ratio:1;--skp-size-0:calc(0.125rem * var(--skp-rem-ratio, 1));--skp-size-1:calc(0.25rem * var(--skp-rem-ratio, 1));--skp-size-2:calc(0.5rem * var(--skp-rem-ratio, 1));--skp-size-3:calc(0.75rem * var(--skp-rem-ratio, 1));--skp-size-4:calc(1rem * var(--skp-rem-ratio, 1));--skp-size-5:calc(1.25rem * var(--skp-rem-ratio, 1));--skp-size-6:calc(1.5rem * var(--skp-rem-ratio, 1));--skp-size-7:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-size-8:calc(2rem * var(--skp-rem-ratio, 1));--skp-size-9:calc(2.25rem * var(--skp-rem-ratio, 1));--skp-size-10:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-size-11:calc(2.75rem * var(--skp-rem-ratio, 1));--skp-size-12:calc(3rem * var(--skp-rem-ratio, 1));--skp-size-13:calc(3.5rem * var(--skp-rem-ratio, 1));--skp-size-14:calc(4rem * var(--skp-rem-ratio, 1));--skp-size-15:calc(5rem * var(--skp-rem-ratio, 1));--skp-size-16:calc(6rem * var(--skp-rem-ratio, 1));--skp-size-17:calc(7rem * var(--skp-rem-ratio, 1));--skp-size-18:calc(8rem * var(--skp-rem-ratio, 1));--skp-size-19:calc(9rem * var(--skp-rem-ratio, 1));--skp-size-20:calc(10rem * var(--skp-rem-ratio, 1));--skp-small-radius:var(--skp-size-1);--skp-medium-radius:var(--skp-size-2);--skp-button-small-height:calc(1.875rem * var(--skp-rem-ratio, 1));--skp-button-medium-height:calc(2.625rem * var(--skp-rem-ratio, 1));--skp-button-large-height:calc(3.25rem * var(--skp-rem-ratio, 1));--skp-button-xlarge-height:calc(4rem * var(--skp-rem-ratio, 1));--skp-button-xxlarge-height:calc(5rem * var(--skp-rem-ratio, 1));--skp-icon-small-height:calc(0.625rem * var(--skp-rem-ratio, 1));--skp-icon-medium-height:calc(1rem * var(--skp-rem-ratio, 1));--skp-icon-large-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-icon-xlarge-height:calc(2.25rem * var(--skp-rem-ratio, 1));--skp-icon-xxlarge-height:calc(3rem * var(--skp-rem-ratio, 1));--skp-tag-small-height:calc(1.5rem * var(--skp-rem-ratio, 1));--skp-tag-medium-height:calc(1.625rem * var(--skp-rem-ratio, 1));--skp-tag-large-height:calc(1.688rem * var(--skp-rem-ratio, 1));--skp-xxsmall-size:calc(0.625rem * var(--skp-rem-ratio, 1));--skp-xsmall-size:calc(0.75rem * var(--skp-rem-ratio, 1));--skp-small-size:calc(0.875rem * var(--skp-rem-ratio, 1));--skp-medium-size:calc(1rem * var(--skp-rem-ratio, 1));--skp-large-size:calc(1.125rem * var(--skp-rem-ratio, 1));--skp-xlarge-size:calc(1.25rem * var(--skp-rem-ratio, 1));--skp-h1-size:calc(3rem * var(--skp-rem-ratio, 1));--skp-h1-small-size:calc(2.438rem * var(--skp-rem-ratio, 1));--skp-h2-size:calc(2.438rem * var(--skp-rem-ratio, 1));--skp-h2-small-size:calc(2.063rem * var(--skp-rem-ratio, 1));--skp-h3-size:calc(2.063rem * var(--skp-rem-ratio, 1));--skp-h3-small-size:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h4-size:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h4-small-size:calc(1.438rem * var(--skp-rem-ratio, 1));--skp-h5-size:calc(1.438rem * var(--skp-rem-ratio, 1));--skp-h5-small-size:calc(1.188rem * var(--skp-rem-ratio, 1));--skp-h6-size:calc(1.188rem * var(--skp-rem-ratio, 1));--skp-h6-small-size:calc(1rem * var(--skp-rem-ratio, 1));--skp-display1-size:calc(4.5rem * var(--skp-rem-ratio, 1));--skp-display2-size:calc(3.75rem * var(--skp-rem-ratio, 1));--skp-h1-line-height:calc(3.5rem * var(--skp-rem-ratio, 1));--skp-h1-small-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h2-line-height:calc(2.95rem * var(--skp-rem-ratio, 1));--skp-h2-small-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h3-line-height:calc(2.5rem * var(--skp-rem-ratio, 1));--skp-h3-small-line-height:calc(2.13rem * var(--skp-rem-ratio, 1));--skp-h4-line-height:calc(2.13rem * var(--skp-rem-ratio, 1));--skp-h4-small-line-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h5-line-height:calc(1.75rem * var(--skp-rem-ratio, 1));--skp-h5-small-line-height:calc(11.45rem * var(--skp-rem-ratio, 1));--skp-h6-line-height:calc(1.45rem * var(--skp-rem-ratio, 1));--skp-h6-small-line-height:calc(1.07rem * var(--skp-rem-ratio, 1));--skp-display1-line-height:calc(5rem * var(--skp-rem-ratio, 1));--skp-display2-line-height:calc(4.5rem * var(--skp-rem-ratio, 1));--skp-filter-small-height:var(--skp-tag-small-height);--skp-filter-medium-height:var(--skp-tag-medium-height);--skp-filter-large-height:var(--skp-tag-large-height);--skp-tooltip-medium:calc(2.063rem * var(--skp-rem-ratio, 1))}:root{--skp-screen-mobile:600px;--skp-screen-tablet:900px;--skp-screen-desktop-sm:1200px;--skp-screen-desktop-md:1800px}:root{--skp-screen-xs:0 2px 8px rgb(0 0 0 / 10%);--skp-screen-xs-border-size-1:4px 6px 8px rgb(0 0 0 / 10%);--skp-screen-xs-invert:0 -2px 8px rgb(0 0 0 / 10%);--skp-shadow-sm:0 4px 12px rgb(0 0 0 / 10%);--skp-shadow-sm-invert:0 -4px 12px rgb(0 0 0 / 10%);--skp-screen-md:0 6px 16px rgb(0 0 0 / 10%);--skp-screen-md-invert:0 -6px 16px rgb(0 0 0 / 10%);--skp-screen-lg:0 8px 20px rgb(0 0 0 / 10%);--skp-screen-lg-invert:0 -8px 20px rgb(0 0 0 / 10%);--skp-screen-xl:0 10px 24px rgb(0 0 0 / 10%);--skp-screen-xl-invert:0 -10px 24px rgb(0 0 0 / 10%)}.d-flex{display:flex}.flex-row{flex-direction:row}.flex-row-reverse{flex-direction:row-reverse}.flex-column{flex-direction:column}.flex-column-reverse{flex-direction:column-reverse}.flex-nowrap{flex-wrap:nowrap}.flex-wrap{flex-wrap:wrap}.flex-wrap-reverse{flex-wrap:wrap-reverse}.flex-0{gap:var(--skp-size-0)}.flex-1{gap:var(--skp-size-1)}.flex-2{gap:var(--skp-size-2)}.flex-3{gap:var(--skp-size-3)}.flex-4{gap:var(--skp-size-4)}.flex-5{gap:var(--skp-size-5)}.flex-6{gap:var(--skp-size-6)}.flex-7{gap:var(--skp-size-7)}.flex-8{gap:var(--skp-size-8)}.flex-9{gap:var(--skp-size-9)}.flex-10{gap:var(--skp-size-10)}.flex-11{gap:var(--skp-size-11)}.flex-12{gap:var(--skp-size-12)}.flex-13{gap:var(--skp-size-13)}.flex-14{gap:var(--skp-size-14)}.flex-15{gap:var(--skp-size-15)}.flex-16{gap:var(--skp-size-16)}.flex-17{gap:var(--skp-size-17)}.flex-18{gap:var(--skp-size-18)}.flex-19{gap:var(--skp-size-19)}.flex-20{gap:var(--skp-size-20)}@media (min-width: 600px){.flex-tb-row{flex-direction:row}.flex-tb-row-reverse{flex-direction:row-reverse}.flex-tb-column{flex-direction:column}.flex-tb-column-reverse{flex-direction:column-reverse}.flex-tb-nowrap{flex-wrap:nowrap}.flex-tb-wrap{flex-wrap:wrap}.flex-tb-wrap-reverse{flex-wrap:wrap-reverse}.flex-tb-0{gap:var(--skp-size-0)}.flex-tb-1{gap:var(--skp-size-1)}.flex-tb-2{gap:var(--skp-size-2)}.flex-tb-3{gap:var(--skp-size-3)}.flex-tb-4{gap:var(--skp-size-4)}.flex-tb-5{gap:var(--skp-size-5)}.flex-tb-6{gap:var(--skp-size-6)}.flex-tb-7{gap:var(--skp-size-7)}.flex-tb-8{gap:var(--skp-size-8)}.flex-tb-9{gap:var(--skp-size-9)}.flex-tb-10{gap:var(--skp-size-10)}.flex-tb-11{gap:var(--skp-size-11)}.flex-tb-12{gap:var(--skp-size-12)}.flex-tb-13{gap:var(--skp-size-13)}.flex-tb-14{gap:var(--skp-size-14)}.flex-tb-15{gap:var(--skp-size-15)}.flex-tb-16{gap:var(--skp-size-16)}.flex-tb-17{gap:var(--skp-size-17)}.flex-tb-18{gap:var(--skp-size-18)}.flex-tb-19{gap:var(--skp-size-19)}.flex-tb-20{gap:var(--skp-size-20)}}@media (min-width: 900px){.flex-sm-row{flex-direction:row}.flex-sm-row-reverse{flex-direction:row-reverse}.flex-sm-column{flex-direction:column}.flex-sm-column-reverse{flex-direction:column-reverse}.flex-sm-nowrap{flex-wrap:nowrap}.flex-sm-wrap{flex-wrap:wrap}.flex-sm-wrap-reverse{flex-wrap:wrap-reverse}.flex-sm-0{gap:var(--skp-size-0)}.flex-sm-1{gap:var(--skp-size-1)}.flex-sm-2{gap:var(--skp-size-2)}.flex-sm-3{gap:var(--skp-size-3)}.flex-sm-4{gap:var(--skp-size-4)}.flex-sm-5{gap:var(--skp-size-5)}.flex-sm-6{gap:var(--skp-size-6)}.flex-sm-7{gap:var(--skp-size-7)}.flex-sm-8{gap:var(--skp-size-8)}.flex-sm-9{gap:var(--skp-size-9)}.flex-sm-10{gap:var(--skp-size-10)}.flex-sm-11{gap:var(--skp-size-11)}.flex-sm-12{gap:var(--skp-size-12)}.flex-sm-13{gap:var(--skp-size-13)}.flex-sm-14{gap:var(--skp-size-14)}.flex-sm-15{gap:var(--skp-size-15)}.flex-sm-16{gap:var(--skp-size-16)}.flex-sm-17{gap:var(--skp-size-17)}.flex-sm-18{gap:var(--skp-size-18)}.flex-sm-19{gap:var(--skp-size-19)}.flex-sm-20{gap:var(--skp-size-20)}}@media (min-width: 1200px){.flex-md-row{flex-direction:row}.flex-md-row-reverse{flex-direction:row-reverse}.flex-md-column{flex-direction:column}.flex-md-column-reverse{flex-direction:column-reverse}.flex-md-nowrap{flex-wrap:nowrap}.flex-md-wrap{flex-wrap:wrap}.flex-md-wrap-reverse{flex-wrap:wrap-reverse}.flex-md-0{gap:var(--skp-size-0)}.flex-md-1{gap:var(--skp-size-1)}.flex-md-2{gap:var(--skp-size-2)}.flex-md-3{gap:var(--skp-size-3)}.flex-md-4{gap:var(--skp-size-4)}.flex-md-5{gap:var(--skp-size-5)}.flex-md-6{gap:var(--skp-size-6)}.flex-md-7{gap:var(--skp-size-7)}.flex-md-8{gap:var(--skp-size-8)}.flex-md-9{gap:var(--skp-size-9)}.flex-md-10{gap:var(--skp-size-10)}.flex-md-11{gap:var(--skp-size-11)}.flex-md-12{gap:var(--skp-size-12)}.flex-md-13{gap:var(--skp-size-13)}.flex-md-14{gap:var(--skp-size-14)}.flex-md-15{gap:var(--skp-size-15)}.flex-md-16{gap:var(--skp-size-16)}.flex-md-17{gap:var(--skp-size-17)}.flex-md-18{gap:var(--skp-size-18)}.flex-md-19{gap:var(--skp-size-19)}.flex-md-20{gap:var(--skp-size-20)}}@media (min-width: 1800px){.flex-lg-row{flex-direction:row}.flex-lg-row-reverse{flex-direction:row-reverse}.flex-lg-column{flex-direction:column}.flex-lg-column-reverse{flex-direction:column-reverse}.flex-lg-nowrap{flex-wrap:nowrap}.flex-lg-wrap{flex-wrap:wrap}.flex-lg-wrap-reverse{flex-wrap:wrap-reverse}.flex-lg-0{gap:var(--skp-size-0)}.flex-lg-1{gap:var(--skp-size-1)}.flex-lg-2{gap:var(--skp-size-2)}.flex-lg-3{gap:var(--skp-size-3)}.flex-lg-4{gap:var(--skp-size-4)}.flex-lg-5{gap:var(--skp-size-5)}.flex-lg-6{gap:var(--skp-size-6)}.flex-lg-7{gap:var(--skp-size-7)}.flex-lg-8{gap:var(--skp-size-8)}.flex-lg-9{gap:var(--skp-size-9)}.flex-lg-10{gap:var(--skp-size-10)}.flex-lg-11{gap:var(--skp-size-11)}.flex-lg-12{gap:var(--skp-size-12)}.flex-lg-13{gap:var(--skp-size-13)}.flex-lg-14{gap:var(--skp-size-14)}.flex-lg-15{gap:var(--skp-size-15)}.flex-lg-16{gap:var(--skp-size-16)}.flex-lg-17{gap:var(--skp-size-17)}.flex-lg-18{gap:var(--skp-size-18)}.flex-lg-19{gap:var(--skp-size-19)}.flex-lg-20{gap:var(--skp-size-20)}}.justify-between{justify-content:space-between}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-around{justify-content:space-around}.justify-evenly{justify-content:space-evenly}@media (min-width: 600px){.justify-tb-between{justify-content:space-between}.justify-tb-start{justify-content:flex-start}.justify-tb-end{justify-content:flex-end}.justify-tb-center{justify-content:center}.justify-tb-around{justify-content:space-around}.justify-tb-evenly{justify-content:space-evenly}}@media (min-width: 900px){.justify-sm-between{justify-content:space-between}.justify-sm-start{justify-content:flex-start}.justify-sm-end{justify-content:flex-end}.justify-sm-center{justify-content:center}.justify-sm-around{justify-content:space-around}.justify-sm-evenly{justify-content:space-evenly}}@media (min-width: 1200px){.justify-md-between{justify-content:space-between}.justify-md-start{justify-content:flex-start}.justify-md-end{justify-content:flex-end}.justify-md-center{justify-content:center}.justify-md-around{justify-content:space-around}.justify-md-evenly{justify-content:space-evenly}}@media (min-width: 1800px){.justify-lg-between{justify-content:space-between}.justify-lg-start{justify-content:flex-start}.justify-lg-end{justify-content:flex-end}.justify-lg-center{justify-content:center}.justify-lg-around{justify-content:space-around}.justify-lg-evenly{justify-content:space-evenly}}.align-start{align-items:flex-start}.align-end{align-items:flex-end}.align-center{align-items:center}.align-stretch{align-items:stretch}.align-baseline{align-items:baseline}.align-unset{align-items:unset}@media (min-width: 600px){.align-tb-start{align-items:flex-start}.align-tb-end{align-items:flex-end}.align-tb-center{align-items:center}.align-tb-stretch{align-items:stretch}.align-tb-baseline{align-items:baseline}.align-tb-unset{align-items:unset}}@media (min-width: 900px){.align-sm-start{align-items:flex-start}.align-sm-end{align-items:flex-end}.align-sm-center{align-items:center}.align-sm-stretch{align-items:stretch}.align-sm-baseline{align-items:baseline}.align-sm-unset{align-items:unset}}@media (min-width: 1200px){.align-md-start{align-items:flex-start}.align-md-end{align-items:flex-end}.align-md-center{align-items:center}.align-md-stretch{align-items:stretch}.align-md-baseline{align-items:baseline}.align-md-unset{align-items:unset}}@media (min-width: 1800px){.align-lg-start{align-items:flex-start}.align-lg-end{align-items:flex-end}.align-lg-center{align-items:center}.align-lg-stretch{align-items:stretch}.align-lg-baseline{align-items:baseline}.align-lg-unset{align-items:unset}}:root{--skp-modal-z-index:110}:root{--skp-main-font:\"roboto\", arial, sans-serif;--skp-font-weight-normal:400;--skp-font-weight-bold:700;--skp-transition:all 0.2s ease-in-out}body,html{font-family:var(--skp-main-font);font-weight:var(--skp-font-weight-normal)}.skp-tooltip-root{box-sizing:border-box;position:fixed;padding:var(--skp-size-2);font:var(--skp-font-weight-normal) var(--skp-small-size) var(--skp-main-font);border-radius:var(--skp-size-1)}.skp-tooltip-root>.skp-tooltip-arrow{position:absolute;width:8px;height:8px;transform:rotate(45deg)}.skp-tooltip-root.skp-tooltip-light{background-color:var(--skp-color-white);color:var(--skp-color-black)}.skp-tooltip-root.skp-tooltip-light>.skp-tooltip-arrow{background-color:var(--skp-color-white)}.skp-tooltip-root.skp-tooltip-dark{background-color:var(--skp-color-neutral-900);color:var(--skp-color-white)}.skp-tooltip-root.skp-tooltip-dark>.skp-tooltip-arrow{background-color:var(--skp-color-neutral-900)}.skp-tooltip-child-container{width:fit-content}";
var Tooltip = /*@__PURE__*/proxyCustomElement( /*#__PURE__*/function (_HTMLElement$) {
  _inherits(Tooltip, _HTMLElement$);

  var _super = _createSuper(Tooltip);

  function Tooltip() {
    var _this;

    _classCallCheck(this, Tooltip);

    _this = _super.call(this);

    _this.__registerHost();

    _this.tooltipOverlayContainer = 'skp-tooltip-overlay-container';
    _this.updateTooltipPosition = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      var middlewares, _yield$computePositio, x, y, placement, middlewareData, arrowSide, _middlewareData$arrow2, arrowX, arrowY;

      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            middlewares = [offset(_this.showArrow ? 8 : 4), flip({
              padding: 4
            }), size({
              padding: 4,
              apply: function apply(_ref8) {
                var availableWidth = _ref8.availableWidth,
                    availableHeight = _ref8.availableHeight,
                    elements = _ref8.elements;
                elements.floating.style.maxWidth = "".concat(Math.max(0, availableWidth), "px"), elements.floating.style.maxHeight = "".concat(Math.max(0, availableHeight), "px");
              }
            }), shift({
              padding: 4
            })];

            if (_this.showArrow) {
              middlewares.push(arrow({
                element: _this.arrow
              }));
            }

            _context8.next = 4;
            return computePosition(_this.childContainer, _this.tooltip, {
              placement: _this.direction,
              strategy: 'fixed',
              middleware: middlewares
            });

          case 4:
            _yield$computePositio = _context8.sent;
            x = _yield$computePositio.x;
            y = _yield$computePositio.y;
            placement = _yield$computePositio.placement;
            middlewareData = _yield$computePositio.middlewareData;
            // Update tooltip position
            _this.tooltip.style.left = "".concat(x, "px");
            _this.tooltip.style.top = "".concat(y, "px");

            if (_this.showArrow) {
              // Arrow is at the opposite side of the tooltip placement
              arrowSide = {
                top: 'bottom',
                right: 'left',
                bottom: 'top',
                left: 'right'
              }[placement.split('-')[0]]; // Split is used to remove the -start or -end part
              // Update arrow position

              _middlewareData$arrow2 = middlewareData.arrow, arrowX = _middlewareData$arrow2.x, arrowY = _middlewareData$arrow2.y;
              _this.arrow.style.left = arrowX !== null ? "".concat(arrowX, "px") : '';
              _this.arrow.style.top = arrowY !== null ? "".concat(arrowY, "px") : '';
              _this.arrow.style.right = '';
              _this.arrow.style.bottom = '';
              _this.arrow.style[arrowSide] = '-4px'; // Half of the arrow size
            }

          case 12:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    _this.direction = 'left';
    _this.showArrow = true;
    _this.text = undefined;
    _this.theme = 'dark';
    return _this;
  }

  _createClass(Tooltip, [{
    key: "removeTooltip",
    value: function removeTooltip() {
      var _a;

      var container = document.getElementById(this.tooltipOverlayContainer);

      if (container) {
        document.body.removeChild(container);
        (_a = this.cleanup) === null || _a === void 0 ? void 0 : _a.call(this);
      }
    }
  }, {
    key: "createTooltip",
    value: function createTooltip() {
      var _clsnms;

      if (!this.text) return;
      this.removeTooltip(); // Create portal container

      this.portal = document.createElement('div');
      this.portal.setAttribute('id', this.tooltipOverlayContainer);
      document.body.append(this.portal); // Create tooltip element

      this.tooltip = document.createElement('div');
      this.tooltip.className = clsnms('skp-tooltip', 'd-flex align-center')('root', this.theme, (_clsnms = {}, _defineProperty(_clsnms, this.direction, this.showArrow), _defineProperty(_clsnms, "withDirection", this.showArrow), _clsnms));
      this.tooltip.innerText = this.text; // Create arrow element

      if (this.showArrow) {
        this.arrow = document.createElement('div');
        this.arrow.className = 'skp-tooltip-arrow';
        this.tooltip.append(this.arrow);
      }

      this.portal.append(this.tooltip);
      this.cleanup = autoUpdate(this.childContainer, this.tooltip, this.updateTooltipPosition);
    }
  }, {
    key: "componentDidLoad",
    value: function componentDidLoad() {
      var _this2 = this;

      var _a, _b, _c, _d;

      (_b = (_a = this.childContainer) === null || _a === void 0 ? void 0 : _a.firstElementChild) === null || _b === void 0 ? void 0 : _b.addEventListener('mouseenter', function () {
        _this2.createTooltip();
      }, {
        passive: true
      });
      (_d = (_c = this.childContainer) === null || _c === void 0 ? void 0 : _c.firstElementChild) === null || _d === void 0 ? void 0 : _d.addEventListener('mouseleave', function () {
        _this2.removeTooltip();
      }, {
        passive: true
      });
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.removeTooltip();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return h(Host, null, h("div", {
        class: "skp-tooltip-child-container",
        ref: function ref(el) {
          return _this3.childContainer = el;
        }
      }, h("slot", null)));
    }
  }, {
    key: "element",
    get: function get() {
      return this;
    }
  }], [{
    key: "style",
    get: function get() {
      return tooltipCss;
    }
  }]);

  return Tooltip;
}(HTMLElement$1), [4, "skp-tooltip", {
  "direction": [1],
  "showArrow": [4, "show-arrow"],
  "text": [1],
  "theme": [1]
}]);

function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }

  var components = ["skp-tooltip"];
  components.forEach(function (tagName) {
    switch (tagName) {
      case "skp-tooltip":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, Tooltip);
        }

        break;
    }
  });
}

var SkpTooltip = Tooltip;
var defineCustomElement = defineCustomElement$1;
export { SkpTooltip, defineCustomElement };